import { useProactiveAccessTokenRefresh } from "./useProactiveAccessTokenRefresh";

export default function ProactiveAccessTokenRefresh() {
  useProactiveAccessTokenRefresh();
  return null;
}
